module.exports = __webpack_public_path__ + "static/assets/640404abe08f905b4fb9a05a1eb0e53c.svg";